import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SNACK_BAR_MESSAGE_TYPES } from 'app/core/models/snackbar/snackbar-model';

@Injectable({
  providedIn: 'root',
})
export class AlertbarService {
  private alertbar = inject(MatSnackBar);

  private showAlertbar(context: string, message: string) {
    this.alertbar.open(message, 'Dismiss', {
      panelClass: [context || SNACK_BAR_MESSAGE_TYPES.DEFAULT],
      verticalPosition: 'bottom',
      horizontalPosition: 'center',
    });
  }

  public showErrorAlert(message: string) {
    this.showAlertbar(SNACK_BAR_MESSAGE_TYPES.ERROR, message);
  }

  public showSuccessAlert(message: string) {
    this.showAlertbar(SNACK_BAR_MESSAGE_TYPES.SUCCESS, message);
  }

  public showWarningAlert(message: string) {
    this.showAlertbar(SNACK_BAR_MESSAGE_TYPES.WARNING, message);
  }

  public showDefaultAlert(message: string) {
    this.showAlertbar(SNACK_BAR_MESSAGE_TYPES.DEFAULT, message);
  }
}
